<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">
        <Modal
            :text="modalText"
            id="modal_show"
        />

        <div class="grid grid-cols-12 gap-3 container">
            <div class="col-span-12 md:col-span-12 position-relative">
                <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute top-3 ml-2">
                    {{ $t('product.title') }}
                </div>
                <SelectSearchInput
                    fetch-name="fetchProductsInWarehouses"
                    get-all-getter-name="getProductsInWarehouses"
                    get-one-getter-name="getProductsInWarehouse"
                    amount-name="quantity"
                    icon="eraser"
                    :models="modelForm.saleProductDtos"
                    :after-fetch="afterFetchProductsInWarehouses"
                    :after-push="afterProductPush"
                    :add-quantity="modss.quant"
                />
            </div>

        </div>

        <RowColumn>

            <!-- add/edit item -->
            <table class="w-full mt-3" v-if="!isActionIdle()">
                <tbody>
                <tr class="h-11 bg-lightGray">
                    <th class="pl-3">{{ $t('product.title') }}</th>
                    <td>{{ item.name }}</td>
                </tr>
                <tr class="h-11">
                    <th class="pl-3">{{ $t('amount') }}</th>
                    <td>
                        <div class="flex justify-start items-center">
                            <div>
                                <b-form-input
                                    type="number"
                                    v-model.number="item.quantity"
                                    :max="item.amount"
                                    class="h-10 border-gray-300 focus:ring-0 w-44"
                                    min="1"
                                />
                            </div>
                            <div class="pl-3 font-bold">
                                {{ showUnitOfMeasure(item.product.unitOfMeasure) }}
                            </div>
                        </div>


                        <InvalidForm
                            :state="item.quantity <= item.amount"
                            :text="$t('validator.type.notEnoughProductsInWarehouse')"
                        />
                    </td>
                </tr>
                </tbody>
            </table>
        </RowColumn>

        <Row class="mt-3 pl-3 pb-4" v-if="!isActionIdle()">
            <Column xs-size="4" sm-size="3">
                <SubmitButton :do-action="addItem" :is-disabled="item.amount < item.quantity" :is-loading="false"/>
            </Column>
            <Column xs-size="4" sm-size="3" v-if="isActionEdit()">
                <ButtonTag :is-tw-deny-btn="true" :do-action="deleteItem"> {{ $t('delete') }}</ButtonTag>
            </Column>
            <Column xs-size="4" sm-size="3">
                <ButtonTag :is-tw-deny-btn="true" :do-action="deleteOrCloseItem"> {{ $t('cancel') }}</ButtonTag>
            </Column>
        </Row>

        <!-- In Card -->
        <Row v-show="isActionIdle()">
            <Column class="mb-4">
                <TableTag
                    v-if="modelForm.saleProductDtos.length > 0"
                    :data="modelForm.saleProductDtos"
                    :headers="['product.title', 'amount', 'actions']"
                    :body-properties="['name', 'quantity', 'actions', ]"
                >
                    <template v-slot:actions="{rowIndex}">
                        <img src="/images/Union.png" @click="remove(rowIndex)" alt="" class="h-6 cursor-pointer">
                    </template>
                </TableTag>
                <div class="mt-3 container" v-if="modelForm.saleProductDtos.length !== 0">
                    <span class="font-bold">{{ $t('productsInWarehouse.writeOffDescription') }}</span>
                    <b-form-textarea
                        class="mt-3 border-gray-300 focus:ring-0"
                        rows="4"
                        v-model="text"
                        :state="text.length >= 3"
                        :placeholder="$t('validator.required')"
                    />
                </div>
            </Column>
        </Row>

        <div class="container mt-3 pb-4">
            <SubmitRow
                v-show="action.type === action.idle && modelForm.saleProductDtos.length > 0 && text.length >= 3"
                text="productsInWarehouse.writeOff"
                :do-action="add"
                :is-loading="isLoading"
            />
        </div>
    </Row>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import currencyFormat from "../../mixin/currencyFormatMixin";
import SubmitRow from "../../components/SubmitRow";
import RowColumn from "../../components/RowColumn";
import Row from "../../components/html/Row";
import Column from "../../components/html/Column";
import SubmitButton from "../../components/html/SubmitButton";
import ButtonTag from "../../components/html/ButtonTag";
import InvalidForm from "../../components/html/InvalidForm";
import TableTag from "../../components/html/TableTag";
import SelectSearchInput from "../../components/SelectSearchInput";
import Modal from "@/components/html/Modal";

export default {
    name: "WriteOff",
    components: {
        Modal,
        SelectSearchInput,
        TableTag,
        InvalidForm,
        ButtonTag,
        SubmitButton,
        Column,
        Row,
        RowColumn,
        SubmitRow,
    },
    data() {
        return {
            text: '',
            totalPrice: 0,
            isLoadedOfficialRate: false,
            isLoadedCompanyRate: false,
            currentExchange: {
                rateUSD: '',
                rateRUB: '',
            },
            data: {
                rate: '',
                currency: '',
                company: ''
            },
            isWantSaveUSD: false,
            isWantSaveRUB: false,
            modalText: '',
            isLoading: false,
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'product.title', url: 'products'},
                {name: 'productsInWarehouse.writeOff', url: ''},
            ],
            modelForm: {
                payedAmount: null,
                isPayed: true,
                saleProductDtos: [],
                soldProducts: [],
                customerId: 0,
                currentCurrency: ''
            },
            modelFormCurrency: 'UZS',
            arrayItem: [],
            action: {
                idle: 0,
                add: 1,
                edit: 2,
                type: 0
            },
            modss: {
                quant: [],
            },
            errors: {
                customerId: null,
            },
        }
    },
    mixins: [currencyFormat],
    computed: {
        ...mapGetters([
            'getProductsInWarehouse',
            'getCurrency',
            'getUserCompanyId',
            'getCurrencies',
            'getProductsInWarehouses',
            'getCurrencyByShortName',
            'getUserCompanyIdAt',
            'getProductsExpiredWriteOff'
        ]),
        item: {
            get() {
                return this.modelForm.saleProductDtos[this.modelForm.saleProductDtos.length - 1]
            },
            set(index) {
                return this.modelForm.saleProductDtos[index]
            }
        }
    },
    methods: {
        ...mapActions([
            'fetchUser',
            'pushProductInWarehouseMakeWriteOff',
            'setBreadcrumbItems'
        ]),
        productsExpiredAddItems() {
            for (let expiredProducts of this.getProductsExpiredWriteOff) {
                if (expiredProducts.soldAmount === null){
                    this.modelForm.saleProductDtos.push({
                        id: expiredProducts.prodactInWarehouseId,
                        quantity: expiredProducts.amount,
                        name: expiredProducts.product.name
                    })
                } else {
                    this.modelForm.saleProductDtos.push({
                        id: expiredProducts.prodactInWarehouseId,
                        quantity: expiredProducts.amount + expiredProducts.soldAmount,
                        name: expiredProducts.product.name
                    })
                }
            }

            this.action.type = this.action.idle
        },
        setAction(action) {
            return this.action.type = action
        },
        isAction(action) {
            return this.action.type === action
        },
        isActionIdle() {
            return this.isAction(this.action.idle)
        },
        isActionAdd() {
            return this.isAction(this.action.add)
        },
        isActionEdit() {
            return this.isAction(this.action.edit)
        },
        isProductSold(soldProducts, saleProduct) {
            for (const product of soldProducts) {
                if (product.id === saleProduct.id) {
                    return true
                }
            }

            return false
        },
        addItem() {
            this.item.constQuantity = this.item.quantity

            this.modelForm.saleProductDtos.forEach(obj => {
                if (obj.id === this.item.id) {
                    if (!this.isProductSold(this.modelForm.soldProducts, this.item)) {
                        this.modelForm.soldProducts.push({id: this.item.id, tpmQuantity: this.item.constQuantity})
                    } else {
                        this.modelForm.soldProducts.forEach((obj) => {
                            if (obj.id === this.item.id) {
                                let index = this.modelForm.soldProducts.indexOf(obj)
                                this.item.constQuantity = this.item.constQuantity + obj.tpmQuantity

                                this.modelForm.soldProducts.splice(index, 1, {
                                    id: this.item.id,
                                    tpmQuantity: this.item.constQuantity
                                })
                            }
                        })
                    }
                }
            })

            this.action.type = this.action.idle
        },
        deleteOrCloseItem() {
            if (this.isActionEdit()) {
                this.setAction(this.action.idle)
            } else {
                this.deleteItem()
            }
        },
        deleteItem() {
            this.modelForm.saleProductDtos.pop()
            this.setAction(this.action.idle)
        },
        afterFetchProductsInWarehouses(models) {
            for (let key in models) {
                let item = models[key]
                item.name = item.product.name + ' (' + item.amount + ' ' + this.showUnitOfMeasure(item.product.unitOfMeasure) + ', ' + item.warehouse.name + ')'
            }

            // todo improve after all fetches
            this.$root.showOverlay = false
        },
        afterProductPush(model) {
            this.setAction(this.action.add);
            model;
        },
        add() {
            this.$root.showOverlay = true

            let data = {
                writeOffItems: [],
                details: this.text
            }

            this.modelForm.saleProductDtos.map((obj) => {
                data.writeOffItems.push({id: obj.id, amount: obj.quantity})
            })

            this.pushProductInWarehouseMakeWriteOff(data)
                .then(() => {
                    this.$i18nHelper.toUrl('products-in-warehouses-write-off')
                })
        },
        afterFetchCustomer(models) {
            if (models.length > 0) {
                this.modelForm.customerId = models[0].id
            }

            for (let index in models) {
                let customer = models[index];

                let name = customer.isCompany ?
                    customer.customerCompany.name :
                    customer.person.givenName + ' ' + customer.person.familyName

                models[index].text = name
            }
        },
        remove(rowIndex) {
            this.modelForm.saleProductDtos.splice(rowIndex, 1)
            this.modelForm.soldProducts.splice(rowIndex, 1)
        }
    },
    watch: {
        getProductsInWarehouses() {
            if(this.getProductsExpiredWriteOff.length > 0 && this.$route.name === 'expired-product-write-off') {
                this.productsExpiredAddItems();
            }
        }
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    }
}
</script>

<style scoped>
.text-light span {
    font-size: 12px;
}

.currency-title {
    font-size: 12px;
    color: #444444;
}

.currency-rate {
    font-weight: 600;
    text-decoration: underline;
    color: #6f42c1;
    cursor: pointer;
}

</style>
